import React from 'react';
import { connect } from 'react-redux';
import { PoiId, BulletinPoiType } from 'utils/entities';
import { ItemWrapper } from 'ds/components/carousels/carousel/styled';
import { Link } from 'components/link';
import { routeByPoiType } from 'utils/marketplaceRoutes';
import { makeByIdsDictionarySelector } from 'store/state/domainData/selectors/common';
import { State } from 'store/state';
import { makeMapStateToPropsFactory, PoiGetter } from 'components/cards/listing/makeMapStateToPropsFactory';
import UniversalCard from 'components/cards/listing/UniversalCard';
import { combinedMarketplaceOfficeListingsSelector } from 'store/state/domainData/selectors/officeListings';


const officeListingsByIdsSelector = makeByIdsDictionarySelector(combinedMarketplaceOfficeListingsSelector);
const poiByIdsSelector: PoiGetter = (state: State, poiId: PoiId) => officeListingsByIdsSelector(state)[poiId];

const makeMapStateToProps = makeMapStateToPropsFactory(poiByIdsSelector);

const ConnectedUniversalCard = connect(makeMapStateToProps)(UniversalCard);

interface OfficeListingsCarouselCardProps {
  type: BulletinPoiType;
  id: string;
}

export const OfficeListingsCarouselCard: React.FC<OfficeListingsCarouselCardProps> = (props) => {
  const { id, type } = props;

  return (
    <ItemWrapper key={id}>
      <Link
        routeName={routeByPoiType(type)}
        routeParams={{ id, tracking_event_source: 'property_carousel' }}
        hideLinkParams
        target="_blank"
      >
        <ConnectedUniversalCard id={id} />
      </Link>
    </ItemWrapper>
  );
};

